export default __webpack_public_path__ + "static/media/Therapy Goals worksheet.b63bea6d.pdf";